import { useReactiveVar } from '@apollo/client'

import { useLoginTokenContext } from './LoginTokenContext'

export default function useIsLoggedIn() {
  const context = useLoginTokenContext()
  const token = useReactiveVar(context)

  return Boolean(token)
}
